import React, { useEffect, useState } from "react";
import { isArray } from "underscore";
import Helper from "../../helper/Helper";
import useReduxState from "src/hooks/useReduxState";
import { useProductStore } from "src/hooks/product";
import { useProductFilterStore } from "src/hooks/productFilter";
import { Beacon } from "src/component/Global/Beacon";

const CommonFilterBoxField = (props) => {
  const { main_label, slug, onFacetsChange } = props;
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [param, setParam] = useState("");
  const [listOfLI, SetListOfLI] = useState([]);
  const [{ productListWithFacet }, { }, { }, { }] = useProductStore();
  const [firstServerCallFilter, setFirstServerCallFilter] = useReduxState(true, 'setFirstServerCallFilter');
  const [optionsAvailable, setOptionsAvailable] = useState([]);
  const [{ filterList, filterBoxExpanded }, { }, { apply_product_filter, clear_product_filter }, { }] = useProductFilterStore();
  useEffect(() => {
    async function fetchHere() {
      processList();
      await setFirstServerCall(false);
    }

    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      await processList();
    }

    if (firstServerCall === false) {
      fetchHere();
    }
  }, [productListWithFacet]);

  const processList = () => {
    if (productListWithFacet?.searchFacets && productListWithFacet?.searchFacets[slug]) {
      SetListOfLI(productListWithFacet?.searchFacets[slug][slug]);
      setOptionsAvailable(productListWithFacet?.searchFacets[slug]);
    }
  };
  const getAppliedFilterStatusByValue = (value) => {
    if (filterList[slug]?.s?.length > 0) {
      let decision = false;
      decision =
        filterList[slug].s?.find((v) => v.value === value) || false;
      return decision;
    }
    return false;
  };

  useEffect(() => {
    if (param === "" && slug === "Categories") {
      if (productListWithFacet?.searchFacets && productListWithFacet?.searchFacets["Categories"] &&
        productListWithFacet?.searchFacets["Categories"]["Categories"] && isArray(productListWithFacet?.searchFacets["Categories"]["Categories"]) &&
        productListWithFacet?.searchFacets["Categories"]["Categories"].length === 1
      ) {
        // Get Nth Child Value
        let nestedObj = findNestedObj(
          productListWithFacet?.searchFacets["Categories"]["Categories"],
          "value"
        );
        if (nestedObj?.value && Object.keys(nestedObj).length > 0) {
          let k = {
            key: slug,
            main_label: main_label,
            value: nestedObj.value,
          };
          if (nestedObj.Level !== undefined) {
            k.hidden_payload = {
              Level: nestedObj.Level,
            };
          }

          apply_product_filter(k);
        }
      }

      setTimeout(() => {
        if (firstServerCallFilter) {
          setFirstServerCallFilter(false)
        }
      }, 1000);

    }
  }, [param]);

  const findNestedObj = (entireObj, keyToFind) => {

    let foundObj = {};
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (Array.isArray(nestedValue) && nestedValue.length > 1) {
        foundObj = undefined;
      } else if (nestedValue && nestedValue[keyToFind] && foundObj) {
        foundObj = nestedValue;
      }
      return nestedValue;
    });
    return foundObj;
  };

  const searchData = (parentItem, dataArray, searchTerm) => {
    try {
      return dataArray.flatMap((obj) => {
        const objHasSearchTerm = Object.entries(obj).some(
          ([key, value]) =>
            key !== "value" &&
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (objHasSearchTerm && !obj.Categories) return [obj];

        const matchedChildren = searchData(
          parentItem,
          obj.Categories ?? [],
          searchTerm
        );

        return objHasSearchTerm || matchedChildren.length > 0
          ? [
            {
              ...obj,
              Categories: matchedChildren,
            },
          ]
          : [];
      });
    } catch (err) {
      return [];
    }
  };

  const checkParent = (obj) => {
    try {
      if (param !== "" && obj?.Categories?.length > 0) {
        return searchData(obj.value, obj.Categories, param);
      }
      if ((param !== "" && obj.Level === 1 && obj.Categories === undefined) || obj.Categories === null) {
        if (obj.value.trim().toLowerCase().includes(param.toLowerCase())) {
          return obj;
        }
        return null;
      }
      return obj;
    } catch (err) {
      return [];
    }
  };

  const getDisplayDecision = (v, i) => {
    if (slug === "Categories") {
      return (
        param !== "" &&
        (checkParent(v) === null || checkParent(v) === undefined || checkParent(v).length === 0)
      );
    }
    return !param ||
      (param && v.value.toLowerCase().includes(param.toLowerCase()))
      ? ""
      : "none";
  };
  const listMaker = (v, i) => {
    return (
      <React.Fragment key={i}>
        <li style={{ display: getDisplayDecision(v, i) ? "none" : "" }}>
          <a
            autoFocus={getAppliedFilterStatusByValue(v.value)}
            className={
              filterList[slug]?.s?.find((exisitingVal) => v.value === exisitingVal.value)
                ? "active" : ""}
            style={{ cursor: "pointer", fontWeight: v.Level === 1 ? "bold" : "", }}
            onClick={() => {
              let d = getAppliedFilterStatusByValue(v.value);
              if (!d) {
                let k = {
                  key: slug,
                  main_label: main_label,
                  value: v.value,
                };
                if (v.Level !== undefined) {
                  k.hidden_payload = {
                    Level: v.Level,
                  };
                }
                apply_product_filter(k)
              } else {
                clear_product_filter({
                  key: slug,
                  selectionIndex: d.i,
                })
              }
              onFacetsChange({ key: slug, value: v.value });
            }}
          >
            {v.main_label}
            <span className="p-1 filter-count">({v.count}) </span>
          </a>
          {v[slug] && v[slug].length > 0 &&
            <>
              {param !== "" ?
                checkParent(v)?.map((v_in, i_in) => (
                  <ul key={Helper.UUID()}>{listMaker(v_in, i_in)}</ul>
                )) :
                v[slug].map((v_in, i_in) => (
                  <ul key={Helper.UUID()}>{listMaker(v_in, i_in)}</ul>
                ))
              }
            </>
          }
        </li>
      </React.Fragment>
    );
  };
  return (
    <>
      {optionsAvailable && optionsAvailable[slug] && optionsAvailable[slug].length > 0 &&
        main_label !== "Attributes" && (
          <div className="col-auto mb-3">
            <div
              className={
                filterBoxExpanded ? "filterbox expanded" : "filterbox"
              }
            >
              <div className="filterbox-header position-relative">
                {main_label === "Category" && <Beacon position={"top"} content={() => "Select a Category to view additional parametric search filters."}
                  opener={() => (
                    <div className="becon-dot"></div>
                  )} />}
                {main_label}
              </div>
              <div className="product_filter_box filterbox-body">
                <form action="" className="search-filter">
                  <div className="bs5 input-group flex-nowrap input-icon-right"
                    id="searchText">
                    <input name="search" id="input_categoryId" type="text"
                      placeholder={"Search " + (main_label.toLocaleLowerCase() === "category"
                        ? "a " : "") + main_label}
                      onChange={async (e) => {
                        const delayDebounceFn = setTimeout(async () => {
                          setParam(e.target.value);
                        }, 500);
                        return () => clearTimeout(delayDebounceFn);
                      }}
                      autoComplete="off"
                    />
                    <span className="bs5 input-group-addon flex-nowrap">
                      <span className="fa fa-search text-black-stone" />
                    </span>
                  </div>
                  <ul className="hierarchical">
                    {listOfLI.length && (
                      <>
                        {listOfLI.map((v, i) => (
                          <React.Fragment key={Helper.UUID()}>
                            {listMaker(v, i)}
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </ul>
                </form>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default CommonFilterBoxField;
